import { useSpinToWin } from 'features';
import { LandingPage } from './LandingPage';
import { ResultsPage } from './ResultsPage';
import { Fade, VStack, useBreakpointValue } from '@telescope/cassini-ui';
import { useWidget } from '@telescope/cassini-hooks';
import { SlotMachineOpen } from 'types';
import { Text, AdUnit, AdUnitSize } from 'components';
import { Campaign } from 'types';

export const SlotMachineGame = () => {
  const { displayResults } = useSpinToWin();

  const { data: widgetData } = useWidget({ select: (data: Campaign) => data.widget });
  const { ads } = widgetData!;

  const { data: rulesData } = 
    useWidget({ select: (data: SlotMachineOpen) => data.widget.global_views.rules });
  const { content: { faqsDescription } } = rulesData!;

  const { data } = useWidget({ select: (data: SlotMachineOpen) => data.snapshot.snapshot_views.landing });
  const { content, settings, styles } = data!;

  const adSize: AdUnitSize = useBreakpointValue({ base: 'mobileLeaderboard', md: 'leaderboard' })!;
  const authAd = ads.auth[adSize];

  return (
    <VStack textAlign="center" spacing={6} mb={2} maxW="100vw" px={4} py={6}>
      <Fade in={!displayResults} transition={{ exit: { duration: 0.2 } }} unmountOnExit={true}>
        <LandingPage />
      </Fade>
      
      <Fade in={displayResults} transition={{ enter: { delay: 0.2, duration: 0.3 } }} unmountOnExit={true}>
        <ResultsPage />
      </Fade>

      <AdUnit size={adSize} alignSelf="center" mx="auto" mt={-2} mb={4} {...authAd}></AdUnit>

      <Text allowMarkdown={true} mb={5}>
        {content.bottomDescription}
      </Text>

      <Text allowMarkdown={true} align="center" fontWeight="semibold">
        {faqsDescription}
      </Text>
    </VStack>
  )
}